import { useEffect } from 'react';
import { useAllowMeStore } from '@/shared/store/allowme';

/**
 * React hook that triggers AllowMe device fingerprint collection on mount.
 *
 * The collected data is stored in the AllowMe Zustand store.
 * Consumers read it via `useAllowMeStore.getState().deviceInfo` at login time.
 */
export function useAllowMeCollect(): void {
  const { collect } = useAllowMeStore();

  useEffect(() => {
    collect('login');
  }, [collect]);
}
